import { SidenavItem } from '../sidenav-item.model';

export const ADD_SIDENAV_ITEM = '[Sidenav] Add Item';
export const UPDATE_SIDENAV_ITEM = '[Sidenav] Update Items';
export const REMOVE_SIDENAV_ITEM = '[Sidenav] Remove Item';
export const TOGGLE_OPEN_SIDENAV_ITEM = '[Sidenav] Toggle Item';
export const SET_CURRENTLY_OPEN_BY_ROUTE = '[Sidenav] Set CurrentlyOpen by Route';
export const SET_ACTIVE_STATE = '[Sidenav] Set Active State';

export class AddSidenavItemAction {
  public static readonly type = ADD_SIDENAV_ITEM;

  constructor(public payload: SidenavItem) {}
}

export class UpdateSidenavItemAction {
  public static readonly type = UPDATE_SIDENAV_ITEM;
}

export class RemoveSidenavItemAction {
  public static readonly type = REMOVE_SIDENAV_ITEM;

  constructor(public payload: SidenavItem) {}
}

export class ToggleOpenSidenavItemAction {
  public static readonly type = TOGGLE_OPEN_SIDENAV_ITEM;

  constructor(public payload: SidenavItem) {}
}

export class SetCurrentlyOpenByRouteAction {
  public static readonly type = SET_CURRENTLY_OPEN_BY_ROUTE;

  constructor(public payload: string) {}
}

export class SetActiveStateAction {
  public static readonly type = SET_ACTIVE_STATE;

  constructor(public payload: SidenavItem) {}
}
